__turbopack_context__.v({
  "className": "plus_jakarta_sans_1211e6fa-module__dwYJqa__className",
  "variable": "plus_jakarta_sans_1211e6fa-module__dwYJqa__variable",
});
